import { defineComponent as t, openBlock as n, createElementBlock as r, normalizeClass as o, renderSlot as s } from "vue";
import { _ as l } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/Banner.css';const c = /* @__PURE__ */ t({
  __name: "Banner",
  props: {
    /**
     * Specifies whether the banner background is slightly transparent.
     */
    transparent: {
      type: Boolean,
      default: !1
    },
    /**
     * for usage outside of pageHero (cards ...)
     */
    card: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (a, d) => (n(), r("div", {
      class: o({
        banner: !e.card,
        transparent: e.transparent,
        card: e.card
      })
    }, [
      s(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), m = /* @__PURE__ */ l(c, [["__scopeId", "data-v-6ed79197"]]);
export {
  m as default
};
